import type { LeaderboardColumnKey } from './types';

export const LEADERBOARD_TABS: LeaderboardColumnKey[] = [
  'winNow',
  'topFactor',
  'topWin',
];
